<div class="row mb-2">
  <h5 class="col-auto">{{ 'Contracts' | translate }}</h5>
</div>

<div class="row">
  <div class="col">
    <ngx-datatable
      class="data-table table-responsive task-list-table"
      [rows]="data?.content"
      [columnMode]="'force'"
      [headerHeight]="50"
      [footerHeight]="50"
      [limit]="10"
      [rowHeight]="40"
    >
      <ngx-datatable-column [flexGrow]="2" name="number">
        <ng-template let-column="column" ngx-datatable-header-template>
          {{ 'Contract.name' | translate }} / {{ 'Contract.number' | translate }}
        </ng-template>
        <ng-template [typedTemplate]="rowType" let-row="row" ngx-datatable-cell-template>
          <a [routerLink]="['/', ADMIN_PREFIX,CONTRACTS_ROUTE,row.number]">{{ row.name }}</a>
          <app-badge-organization [code]="row.number" />
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column [flexGrow]="1" name="type">
        <ng-template let-column="column" ngx-datatable-header-template>
          {{ 'Contract.type' | translate }}
        </ng-template>
        <ng-template [typedTemplate]="rowType" let-row="row" ngx-datatable-cell-template>
          {{ 'Contract.typeEnum.' + row.type | translate }}
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column [flexGrow]="2" name="holder">
        <ng-template let-column="column" ngx-datatable-header-template>
          {{ 'Contract.holder' | translate }}
        </ng-template>
        <ng-template [typedTemplate]="rowType" let-row="row" ngx-datatable-cell-template>
          <a [routerLink]="['/',ADMIN_PREFIX,ORGANIZATIONS_ROUTE,row.holder.code]">{{ row.holder.name }}</a>
          <app-badge-organization [code]="row.holder.code"></app-badge-organization>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column [flexGrow]="1" name="startDate">
        <ng-template let-column="column" ngx-datatable-header-template>
          {{ 'Contract.startDate' | translate }}
        </ng-template>
        <ng-template [typedTemplate]="rowType" let-row="row" ngx-datatable-cell-template>
          {{ row.startDate | date }}
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column [flexGrow]="1" name="endDate">
        <ng-template let-column="column" ngx-datatable-header-template>
          {{ 'Contract.endDate' | translate }}
        </ng-template>
        <ng-template [typedTemplate]="rowType" let-row="row" ngx-datatable-cell-template>
          {{ row.endDate | date }}
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-footer>
        <ng-template ngx-datatable-footer-template>
          <app-table-pager [data]="data" [page]="page" (changePage)="changePage($event)" />
        </ng-template>
      </ngx-datatable-footer>
    </ngx-datatable>
  </div>
</div>
